// Role helpers — single source of truth for the client's cosmetic role checks.
// (Real enforcement is server-side; these only drive nav visibility and labels.)
//
//   admin > reseller
//   admin     full access: sees all data, reaches User Mgmt/Alerts, and may
//             create/manage any account including other admins.
//   reseller  scoped to its own reseller_name; no management screens.
//
// `p` is the profile object from useAuth() (may be null while loading).

export const ROLE_LABELS = {
  admin: 'Administrator',
  reseller: 'Reseller',
};

export const roleLabel = (role) => ROLE_LABELS[role] || role || '—';

export const isAdminOrAbove = (p) => p?.role === 'admin';

// Roles an actor may create/manage (used to gate the Add-account role picker and
// per-row actions in User Management).
export function manageableRoles(p) {
  return p?.role === 'admin' ? ['admin', 'reseller'] : [];
}

// Can this actor act on a target account with the given role?
export const canManage = (p, targetRole) => manageableRoles(p).includes(targetRole);
